import React from "react";

const DYNAMIC_FIELD_LABELS = {
    equipment_name: "Matériel", equipment_id: "ID Matériel", serial_number: "Numéro de série",
    defect_type: "Type de défaut", criticality: "Criticité", since_when: "Depuis quand",
    workaround_available: "Contournement disponible", workaround_description: "Description du contournement",
    date_start: "Date de début", date_end: "Date de fin", destination: "Destination", motif: "Motif",
    good_condition_confirmed: "Bon état confirmé", returned_date: "Date de retour", return_condition: "État au retour",
    account_name: "Nom du compte", issue_type: "Type de problème", verification_method: "Méthode de vérification",
    transmission_method: "Méthode de transmission", software_name: "Logiciel", software_version: "Version",
    software_category: "Catégorie logiciel", justification: "Justification", access_type: "Type d'accès",
    resource_name: "Ressource", start_date: "Date de début", end_date: "Date de fin",
    employee_name: "Nom de l'employé", employee_email: "Email de l'employé", position: "Poste",
    manager_name: "Manager", department_name: "Département", description: "Description",
    impact: "Impact", urgency: "Urgence", frequency: "Fréquence", affected_users: "Utilisateurs affectés",
    change_type: "Type de changement", risk_level: "Niveau de risque", rollback_plan: "Plan de rollback",
    implementation_date: "Date de mise en œuvre",
    request_subject: "Objet de la demande",
    license_type: "Type de licence", license_count: "Nombre de licences",
    license_beneficiaries: "Bénéficiaire(s) de la licence",
    topic: "Sujet", target_machine: "Machine cible", urgency_reason: "Raison d'urgence",
    software_items: "Logiciels demandés", download_url: "Lien de téléchargement",
};

function formatLabel(key) {
    return DYNAMIC_FIELD_LABELS[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

function renderDynamicValue(value) {
    if (value === null || value === undefined) return "—";
    if (typeof value === "boolean") return value ? "Oui" : "Non";
    if (Array.isArray(value)) {
        if (value.length === 0) return "—";
        if (typeof value[0] === "object" && value[0] !== null) {
            return (
                <ul className="list-disc list-inside space-y-1">
                    {value.map((item, i) => (
                        <li key={item.id || item.software_id || item.name || i}>
                            <span className="font-medium">{item.name || item.software_name || "Élément"}</span>
                            {item.version && ` (v${item.version})`}
                            {(item.url || item.download_url) && (
                                <>
                                    {" — "}
                                    <a
                                        href={item.url || item.download_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:underline"
                                    >
                                        Télécharger
                                    </a>
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            );
        }
        return value.join(", ");
    }
    if (typeof value === "object" && value !== null) {
        return (
            <div className="space-y-1">
                {Object.entries(value).map(([k, v]) => (
                    <div key={k} className="text-sm">
                        <span className="font-medium">{formatLabel(k)}</span> : {String(v ?? "—")}
                    </div>
                ))}
            </div>
        );
    }
    return String(value);
}

export function TicketDynamicFields({ fields }) {
    if (!fields || Object.keys(fields).length === 0) return null;
    return (
        <div className="card">
            <div className="card-header">
                <h2 className="text-sm font-semibold text-gray-900">
                    Détails spécifiques
                </h2>
            </div>
            <div className="card-body">
                <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {Object.entries(fields).map(([key, value]) => (
                        <div key={key} className={Array.isArray(value) && value.length > 0 && typeof value[0] === "object" ? "md:col-span-2" : ""}>
                            <dt className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
                                {formatLabel(key)}
                            </dt>
                            <dd className="text-sm text-gray-900">
                                {renderDynamicValue(value)}
                            </dd>
                        </div>
                    ))}
                </dl>
            </div>
        </div>
    );
}
